<template>
  <div v-if="value || !!$slots.default">
    <label
      :class="{
        [props.labelSize as string]: !!props.labelSize,
        'text-sm': !props.labelSize && boldLabel,
        'text-xs': !props.labelSize && !boldLabel,
        'text-yapgray-600 dark:text-yapgray-500': !boldLabel,
        'block font-medium leading-6 text-yapgray-900 dark:text-yapgray-200': boldLabel
      }"
    >
      {{ label }} <span v-if="required" class="text-yapred-400 dark:text-yapred-500">*</span>
    </label>
    <div class="text-sm" v-if="!!$slots.default">
      <slot />
    </div>
    <div class="text-sm" v-else>
      <code v-if="monospacedValue">{{ value }}</code>
      <span v-else>{{ value }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  label: string;
  value?: string;
  monospacedValue?: boolean;
  required?: boolean;
  boldLabel?: boolean;
  labelSize?: string;
}>();
</script>
